import { render, staticRenderFns } from "./LoadedSearch.vue?vue&type=template&id=661c7748&"
import script from "./LoadedSearch.vue?vue&type=script&lang=js&"
export * from "./LoadedSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports